<template>
    <div>
        <form action="#l" method="post">
            <div class="title-container">
                <h2 class="search-title">{{ searchboxheadlineflightseat[getCurrentLocale] }}</h2>
                <p>{{ searchboxheadlineflights2[getCurrentLocale] }}</p>
                <i class="soap-icon-passenger"></i>
            </div>


            <div class="search-content">
                <div id="main" class="col-md-12" style="margin-bottom: 0px;">
                    <h4 class="skin-color">{{ seatstitle[getCurrentLocale] }}</h4>
                    <p>{{ seatstitle2[getCurrentLocale] }}</p>
                    <br />
                    <div class="image-box style9 column-4">
                        <article class="box">
                            <center>
                                <figure>
                                    <a href="#" title="" class=""><img src="/res/images/services/seats/types/seat1.png" alt="" width="30" height="30" style="background-color: #FF6600;" /></a>
                                </figure>
                                <div class="details">
                                    <a href="/infos-seat-reservation/#/seat-reservation" title="" class="button" style="margin-top: 10px; margin-bottom: 20px;" target="_new">{{ moreinfo[getCurrentLocale] }}</a>
                                    <h4 class="box-title">
                                        Comfort<br />Seat<br /><br />
                                        <span style="margin-top:5px; margin-bottom:10px; font-size: 20px; color: rgb(125, 185, 33);">{{ Number(30) | rndAmntRUAFWZ }}</span>
                                        <small><br />{{ furtherservices_seat_comfortseat[getCurrentLocale] }}</small>
                                    </h4>
                                </div>
                            </center>
                        </article>

                        <article class="box">
                            <center>
                                <figure>
                                    <a href="#" title="" class=""><img src="/res/images/services/seats/types/seat1.png" alt="" width="30" heigth="30" style="background-color: #9900CC;"></a>
                                </figure>
                                <div class="details">
                                    <a href="/infos-seat-reservation/#/seat-reservation" title="" class="button" style="margin-top: 10px; margin-bottom: 20px;" target="_new">{{ moreinfo[getCurrentLocale] }}</a>
                                    <h4 class="box-title">
                                        Best<br />Seat<br /><br />
                                        <span style="margin-top:5px; margin-bottom:10px; font-size: 20px; color: rgb(125, 185, 33);">{{ Number(20) | rndAmntRUAFWZ }}</span>
                                        <small><br />{{ furtherservices_seat_bestseat[getCurrentLocale] }}</small>
                                    </h4>
                                </div>
                            </center>
                        </article>

                        <article class="box">
                             <center>
                                <figure>
                                    <a href="#" title="" class=""><img src="/res/images/services/seats/types/seat1.png" alt="" width="30" heigth="30" style="background-color: #22B14C;"></a>
                                </figure>
                                <div class="details">
                                    <a href="/infos-seat-reservation/#/seat-reservation" title="" class="button" style="margin-top: 10px; margin-bottom: 20px;" target="_new">{{ moreinfo[getCurrentLocale] }}</a>
                                    <h4 class="box-title">
                                        Standard<br />Seat<br /><br />
                                        <span style="margin-top:5px; margin-bottom:10px; font-size: 20px; color: rgb(125, 185, 33);">{{ Number(15) | rndAmntRUAFWZ }}</span>
                                        <small><br /></small>
                                    </h4>
                                </div>
                             </center>
                        </article>

                        <article class="box">
                             <center>
                                <figure>
                                    <a href="#" title="" class=""><img src="/res/images/services/seats/types/seat1.png" alt="" width="30" heigth="30" style="background-color: #3399FF;"></a>
                                </figure>
                                <div class="details">
                                    <a href="/infos-seat-reservation/#/seat-reservation" title="" class="button" style="margin-top: 10px; margin-bottom: 20px;" target="_new">{{ moreinfo[getCurrentLocale] }}</a>
                                    <h4 class="box-title">
                                        Exit<br />Seat<br /><br />
                                        <span style="margin-top:5px; margin-bottom:10px; font-size: 20px; color: rgb(125, 185, 33);">{{ Number(30) | rndAmntRUAFWZ }}</span>
                                        <small><br />{{ furtherservices_seat_exitseat[getCurrentLocale] }}</small>
                                    </h4>
                            </div>
                             </center>
                        </article>
                    </div>
                </div>


                <div id="honeymoon1" class="tab-pane fade in active image-style style2">
                    <div class="row">
                        <div class="col-md-12 column-in-center">
                            <ul style="" class="image-block clearfix">
                                <li style="z-index: 5; left: 50px; top; 10px;">
                                    <a style="width: 80px; height: 80px; position: relative;"
                                        class="middle-block" href="/services">
                                        <img width="133" height="88" alt="" src="/res/images/services/seats/tabs_banner_5.png"
                                            class="middle-item"
                                            style="position: absolute; top: 50%; margin-top: -40px; left: 50%; margin-left: -66.5px;">
                                    </a>
                                </li>
                                <li style="z-index: 4; left: 180px; top: 100px;">
                                    <a style="width: 100px; height: 100px; position: relative;"
                                        class="middle-block" href="/services">
                                        <img width="150" height="100" alt="" src="/res/images/services/seats/tabs_banner_4.jpg"
                                            class="middle-item"
                                            style="position: absolute; top: 50%; margin-top: -50px; left: 50%; margin-left: -75px;">
                                    </a>
                                </li>
                                <li style="z-index: 3; left: 250px; top: 20px;">
                                    <a style="width: 150px; height: 150px; position: relative;"
                                        class="middle-block" href="/services">
                                        <img width="220" height="196" alt="" src="/res/images/services/seats/tabs_banner_2.png"
                                            class="middle-item"
                                            style="position: absolute; top: 50%; margin-top: -75px; left: 50%; margin-left: -110px;">
                                    </a>
                                </li>
                                <li style="z-index: 2; left: 100px; top: 0;">
                                    <a style="width: 160px; height: 160px; position: relative;"
                                        class="middle-block" href="/services">
                                        <img width="312" height="208" alt="" src="/res/images/services/seats/tabs_banner_3.png"
                                            class="middle-item"
                                            style="position: absolute; top: 50%; margin-top: -80px; left: 50%; margin-left: -156px;">
                                    </a>
                                </li>
                                <li style="z-index: 1; left: 0; top: 30px;">
                                    <a style="width: 156px; height: 156px; position: relative;"
                                        class="middle-block" href="/services">
                                        <img width="235" height="156" alt="" src="/res/images/services/seats/tabs_banner_1.jpg"
                                            class="middle-item"
                                            style="position: absolute; top: 50%; margin-top: -78px; left: 50%; margin-left: -117.5px;">
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <br /><br /><br />
                    <a href="/services" class="button btn-medium icon-check uppercase full-width">{{ seatsbutton[getCurrentLocale] }}</a>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';

    export default {

        /* >>> *************************************************************** /  /* Data */
        data: function() {

            return {
                searchboxheadlineflightseat: {
                    en: 'Seats',
                    de: 'Sitzplätze',
                },
                searchboxheadlineflights2: {
                    en: 'Discover the world with SUNDAIR!',
                    de: 'Entdecke die Welt mit SUNDAIR!',
                },
                seatstitle: {
                    en: 'Reserve your desired seat!',
                    de: 'Reservieren Sie sich Ihren Wunschsitzplatz!',
                },
                seatstitle2: {
                    en: 'The following seating categories are available:',
                    de: 'Folgende Sitzplatzkategorien stehen zur Wahl:',
                },
                seatsbutton: {
                    en: 'Directly to seat booking',
                    de: 'Direkt zur Sitzplatz Buchung',
                },

                furtherservices_seat_comfortseat: {
                    en: 'Seats in the 1st row with plenty of legroom',
                    de: 'Sitzplätze in der 1. Reihe mit viel Beinfreiheit',
                },
                furtherservices_seat_comfortseat: {
                    en: 'SEATS IN THE 1ST ROW',
                    de: 'SITZPLÄTZE IN DER 1. REIHE',
                },
                furtherservices_seat_bestseat: {
                    en: 'Seats in the 2nd - 7th row',
                    de: 'Sitzplätze in der 2.-7. Reihe',
                },
                furtherservices_seat_exitseat: {
                    en: 'SEATS DIRECTLY AT THE EMERGENCY EXIT',
                    de: 'SITZPLÄTZE AM NOTAUSGANG',
                },
                moreinfo: {
                    en: 'MORE INFO',
                    de: 'MEHR INFOS',
                },
                // currentLocale: 'de',
            };

        }, // eof data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'getCurrentLocale',
            ]),

        }, // eof computed{}
        /* <<< ****************************************************************/

    };
</script>

<style scoped>
    .md-section {
        padding-top: 0px;
    }

    .image-style {
        padding-top: 10px;
        padding-right: 0px;
        padding-bottom: 10px;
        padding-left: 10px;
    }

    .column-in-center {
        margin-left: 60px;
    }
    @media only screen
    and (min-device-width : 768px)
    and (max-device-width : 1024px)  {
        .column-in-center {
            margin-left: 0px;
        }
    }

    .image-box.style9 figure img {
        width: 50%
    }

    a.button {
        background: #ffb400;
    }
</style>

